import { createMuiTheme } from '@material-ui/core/styles'
import styles from './styles'
import components from './components'


const theme = createMuiTheme({ ...styles, ...components })
export default theme
